import { ToastContainer } from '../../PageBuilder/helpers/toast';

export default props => <ToastContainer {...props} />;
